export default async function minifyHTML(input) {
  const {minify} = await import('html-minifier-terser')
  return await minify(input, {
    noNewlinesBeforeTagClose: true,
    collapseWhitespace: true,
  })
}
